const KEY = 'zjhome';
const TokenKey = `${KEY}-token`;
const UserInfoKey = `${KEY}-userinfo`;
const UserIdKey = `${KEY}-userid`;
const publicConfigKey = `${KEY}-publicConfig`;
const companyNameKey = `${KEY}-companyName`;

export function getCompany() {
    return localStorage.getItem(companyNameKey);
}

export function setCompany(data) {
    return localStorage.setItem(companyNameKey, data)
}
export function getToken() {
    return localStorage.getItem(TokenKey);
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return localStorage.removeItem(TokenKey)
}

export function getUserId() {
    return localStorage.getItem(UserIdKey);
}
export function setUserId(id) {
    return localStorage.setItem(UserIdKey, id);
}

export function getUserInfo() {
    let userInfo = localStorage.getItem(UserInfoKey);
    return userInfo ? JSON.parse(userInfo) : {};
}
export function setUserInfo(data) {
    return localStorage.setItem(UserInfoKey, JSON.stringify(data));
}
export function getAuthInfo() {
    let authInfo = localStorage.getItem('authInfo');
    return authInfo ? JSON.parse(authInfo) : {};
}

export function getConfig() {
    let config = localStorage.getItem(publicConfigKey);
    return config ? JSON.parse(config) : null;
}

export function setConfig(config) {
    config = JSON.stringify(config);
    return localStorage.setItem(publicConfigKey, config);
}